import { render, staticRenderFns } from "./AudioDataTable.vue?vue&type=template&id=b365b796&scoped=true&"
import script from "./AudioDataTable.vue?vue&type=script&lang=ts&"
export * from "./AudioDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./AudioDataTable.vue?vue&type=style&index=0&id=b365b796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b365b796",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VDataTable,VTextField})
